import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { ProjectElementCommentRequest } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { getComments } from 'cd-eft/components/Projects/Project/ProjectVM'

const libraryStore = stores.AppStore.projectsLibraryStore;
const projectClassId = 1;  //Design project
export class StructureCommentsVM {
    @observable props;
    @observable projectId: string;
    @observable checkedState: any = []
    @observable readOnlyFormActive: boolean = true;
    @observable addFormActive: boolean = false;
    @observable editFormActive: boolean = false;
    @observable deleteFormActive: boolean = false;
    @observable cancelFormBtnActive: boolean = false;
    @observable editCheckboxes: boolean = false;
    @observable deleteFormBtnActive: boolean = false
    @observable deleteCheckboxes: boolean = false;
    @observable deletePopup: boolean = false;
    @observable currentStructureList: any = []
    commentTypeId: number = 2;
    constructor(props) {
        this.props = props;
        this.projectId = this.props.projectId;
        this.currentStructureList = this.props.currentStructureList;
    }

    elementActions = {
        Edit: { action: this.toggleEditFormOn },
        Delete: { action: this.toggleDeleteFormOn },
        Add: { action: this.toggleAddFormOn },
    };

    // Structure Comments
    @observable createStructureDesignCommentForm: ICreateStructureCommentForm = {
        projectUuid: '',
        commentTypeId: this.commentTypeId,
        designTypeAndStructureName: '',
        commentAuthor: String(localStorage['username']),
        projectComment: '',
        editStatus: 'add'
    };

    @observable editStructureCommentForm: ICommentForm = {
        projectUuid: '',
        commentTypeId: this.commentTypeId,
        projectElementCommentId: 0,
        designTypeAndStructureName: '',
        commentAuthor: String(localStorage['username']),
        projectComment: '',
        editStatus: 'update'
    };


    // Form Validation model
    @observable formValidation = {
        formErrors: {
            projectUuid: '',
            commentTypeId: '',
            commentAuthor: '',
            designTypeAndStructureName: '',
            projectComment: '',
            editStatus: ''
        },
        projectUuid: false,
        commentTypeId: false,
        commentAuthor: false,
        designTypeAndStructureName: false,
        projectComment: false,
        editStatus: false,
        formValid: false,
    };

    @action.bound toggleReadOnlyFormOn() {
        this.readOnlyFormActive = !this.readOnlyFormActive
    }

    @action.bound toggleAddFormOn() {
        this.addFormActive = !this.addFormActive;
        this.cancelFormBtnActive = false;
        this.editFormActive = false;
        this.deleteFormActive = false;
        this.readOnlyFormActive = true;
        this.clearErrors()
    }

    @action.bound toggleEditFormOn() {
        this.editFormActive = !this.editFormActive
        this.cancelFormBtnActive = true;
        this.addFormActive = false
        this.deleteFormActive = false;
        this.resetEditStructureCommentForm();
        this.toggleReadOnlyFormOn()
        this.clearErrors()
    }

    @action.bound toggleDeleteFormOn() {
        this.deleteFormActive = !this.deleteFormActive
        this.cancelFormBtnActive = false;
        this.addFormActive = false
        this.editFormActive = false;
        this.readOnlyFormActive = true;
        this.checkedState = new Array(libraryStore.structureComments.length).fill(false)
    }

    @action.bound toggleDeletePopup() {
        this.deletePopup = true;
    }

    @action.bound resetComments() {
        this.clearErrors()
        this.addFormActive = false
        this.readOnlyFormActive = true;
        this.editFormActive = false;
        this.cancelFormBtnActive = false
        this.deleteFormActive = false;
        this.deletePopup = false;
        this.resetCreateCommentForm()
        this.resetEditStructureCommentForm();
    }

    @action.bound resetCreateCommentForm() {
        this.createStructureDesignCommentForm = {
            projectUuid: '',
            commentTypeId: this.commentTypeId,
            designTypeAndStructureName: '',
            commentAuthor: String(localStorage['username']),
            projectComment: '',
            editStatus: 'add'
        }
    }

    @action.bound resetEditStructureCommentForm() {
        this.editStructureCommentForm = {
            projectUuid: '',
            commentTypeId: this.commentTypeId,
            projectElementCommentId: 0,
            designTypeAndStructureName: '',
            commentAuthor: String(localStorage['username']),
            projectComment: '',
            editStatus: 'update'
        };
        this.checkedState = new Array(libraryStore.structureComments.length).fill(false)
    }

    @action.bound cancelComment() {
        this.resetComments()
    }

    @action.bound cancelEditComment(position) {
        this.resetEditStructureCommentForm();
        this.cancelFormBtnActive = true;
    }


    // form validation by field
    @action.bound validateField(fieldName, value) {
        if (value === undefined) {
            return;
        }
        // connects form field to validation table
        const keyValid = fieldName + 'Valid';
        let fieldValid = this.formValidation[keyValid];
        const fieldValidationErrors = this.formValidation.formErrors;
        switch (fieldName) {
            case 'projectUuid':
                // is required value 
                fieldValid = value !== ''
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'projectUuid is required';
                break;
            case 'commentTypeId':
                // is required and value should not be 0
                fieldValid = value !== '' && value !== 0;
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'commentTypeId is required';
                break;
            case 'commentAuthor':
                // is required value
                fieldValid = value !== '';
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'commentAuthor is required';
                break;
            case 'editStatus':
                // is required value
                fieldValid = value !== '';
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'editStatus is required';
                break;
            case 'designTypeAndStructureName':
                // is required and value 
                fieldValid = value !== ''
                fieldValidationErrors[fieldName] = fieldValid
                    ? ''
                    : 'designTypeAndStructureName is required';
                break;
            case 'projectComment':
                // is required and value should not be null
                fieldValid = value !== '' && value !== null;
                fieldValidationErrors[fieldName] = fieldValid ? '' : 'Design comment is required';
                break;
            default:
                break;
        }
        this.formValidation.formErrors = fieldValidationErrors;
        this.formValidation[keyValid] = fieldValid;
        this.validateForm();
    }

    // checks if there are any error msgs over entire form
    @action.bound validateForm() {
        let valid = true;
        for (const key in this.formValidation.formErrors) {
            if (!this.formValidation[key + 'Valid']) {
                valid = false;
            }
        }
        this.formValidation.formValid = valid;
    }

    @action.bound errorClass(field) {
        const errorMessage = this.formValidation.formErrors[field];
        return errorMessage.length === 0 ? '' : ' usa-input--error';
    }

    @action.bound clearErrors() {
        this.formValidation = {
            formErrors: {
                projectUuid: '',
                commentTypeId: '',
                commentAuthor: '',
                designTypeAndStructureName: '',
                projectComment: '',
                editStatus: ''
            },
            projectUuid: false,
            commentTypeId: false,
            commentAuthor: false,
            designTypeAndStructureName: false,
            projectComment: false,
            editStatus: false,
            formValid: false,
        }
    }
    @action.bound handleSubmit = e => {
        e.preventDefault();
    }


    @action.bound handleInput(event) {
        event.preventDefault();
        const { name, value } = event.target;
        this.createStructureDesignCommentForm[name] = value
        this.validateField(name, value);
    }

    @action.bound handleInputChange(event, position) {
        event.preventDefault();
        const { name, value } = event.target;
        this.editStructureCommentForm[name] = value;
        this.validateField(name, value);
    }

    @action.bound handleCheckBox(position) {
        this.cancelFormBtnActive = false
        this.checkedState = this.checkedState.map((item, index) =>
            index === position ? !item : item
        );

        this.editStructureCommentForm.projectUuid = libraryStore.structureComments[position].projectUuid
        this.editStructureCommentForm.projectElementCommentId = libraryStore.structureComments[position].projectElementCommentId
        this.editStructureCommentForm.commentTypeId = libraryStore.structureComments[position].commentTypeId
        this.editStructureCommentForm.designTypeAndStructureName = libraryStore.structureComments[position].designTypeAndStructureName
        this.editStructureCommentForm.projectComment = libraryStore.structureComments[position].projectComment
    }

    @action.bound handleDeleteCheckBox(position) {
        this.checkedState = this.checkedState.map((item, index) =>
            index === position ? !item : item
        );
    }

    @action.bound async createComment() {
        this.createStructureDesignCommentForm.projectUuid = this.projectId

        if (!this.formValidation.formValid) {
            for (const field in this.createStructureDesignCommentForm) {
                const value = this.createStructureDesignCommentForm[field];
                this.validateField(field, value);
            }
            // If invalid - return and halt execution
            if (!this.formValidation.formValid) {
                return;
            }
        }

        let selectedStructureId
        if (this.currentStructureList) {
            selectedStructureId = this.currentStructureList.find(e => e.name === this.createStructureDesignCommentForm.designTypeAndStructureName).id
        }
        const structurePostJSON: ProjectElementCommentRequest = {
            projectUuid: this.createStructureDesignCommentForm.projectUuid,
            commentTypeId: this.createStructureDesignCommentForm.commentTypeId,
            designElementId: selectedStructureId,
            designTypeAndStructureName: this.createStructureDesignCommentForm.designTypeAndStructureName,
            commentAuthor: this.createStructureDesignCommentForm.commentAuthor,
            projectComment: this.createStructureDesignCommentForm.projectComment,
            editStatus: this.createStructureDesignCommentForm.editStatus,
        };

        MessageCenter.clearMessages();
        try {
            const response = await PRJAPI.ProjectElementCommentController.createProjectElementCommentByProjectUuidUsingPOST(structurePostJSON)
            if (response.data) {
                await getComments(this.createStructureDesignCommentForm.projectUuid, projectClassId)
            }
            this.resetComments()
            this.props.updateCallback();
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        }
    }

    @action.bound async saveEditComment() {
        if (!this.formValidation.formValid) {
            for (const field in this.editStructureCommentForm) {
                const value = this.editStructureCommentForm[field];
                this.validateField(field, value);
            }
            // If invalid - return and halt execution
            if (!this.formValidation.formValid) {
                return;
            }
        }
        let selectedStructureId
        if (this.currentStructureList) {
            selectedStructureId = this.currentStructureList.filter(e => e.name === this.editStructureCommentForm.designTypeAndStructureName).id
        }

        const postJSON = {
            projectUuid: this.editStructureCommentForm.projectUuid,
            commentTypeId: this.editStructureCommentForm.commentTypeId,
            projectElementCommentId: this.editStructureCommentForm.projectElementCommentId,
            designElementId: selectedStructureId,
            designTypeAndStructureName: this.editStructureCommentForm.designTypeAndStructureName,
            commentAuthor: this.editStructureCommentForm.commentAuthor,
            projectComment: this.editStructureCommentForm.projectComment,
            editStatus: this.editStructureCommentForm.editStatus
        };

        try {
            await PRJAPI.ProjectElementCommentController.editProjectElementCommentByProjectElementCommentIdUsingPOST(postJSON)
            await getComments(this.editStructureCommentForm.projectUuid, projectClassId)
            this.resetComments()
            this.props.updateCallback();
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        }
    }


    @action.bound async handleDeleteComments() {
        const postJSON = {
            projectElementCommentIdList: libraryStore.structureComments.filter((comment, index) => this.checkedState[index]).map(data => data.projectElementCommentId),
            projectUuid: this.projectId
        };
        try {
            await PRJAPI.ProjectElementCommentController.deleteProjectElementCommentsByProjectElementCommentIdsUsingPOST(postJSON)
            await getComments(this.projectId, 1)
            this.resetComments()
            this.props.updateCallback();
        } catch (error) {
            MessageCenter.addError((error as Error).message);
        }
    }
}

interface ICreateStructureCommentForm {
    projectUuid: string;
    commentTypeId: number;
    designTypeAndStructureName: string;
    commentAuthor: string;
    projectComment: string;
    editStatus: string;
}

interface ICommentForm {
    projectUuid: string;
    projectElementCommentId: number
    commentTypeId: number;
    designTypeAndStructureName: string;
    commentAuthor: string;
    projectComment: string;
    editStatus: string;
}